import React, { useEffect, useState } from 'react'
import NavbarForProductList from './NavbarProduct';

const MessageList = () => {
    const [messageList, setMessageList] = useState([]);
    const showMessageList = async () => {
        const req = await fetch(`https://jivichem.herokuapp.com/api/v1/message/messageList`);

        const data = await req.json();

        const listOfMessage = data.getMessage;

        setMessageList(...messageList, listOfMessage);
        console.log(listOfMessage);
    }

    useEffect(() => {
        showMessageList();
    }, [])

    return (
        <>
            <NavbarForProductList />
            <align className="right">
            </align>
            <table className="center">
                <thead>
                    <tr>
                        <th>
                            <font color="midnightblue">S. No.</font>
                        </th>
                        <th>
                            <font color="midnightblue">Name</font>
                        </th>
                        <th>
                            <font color="midnightblue">Phone</font>
                        </th>
                        <th>
                            <font color="midnightblue">Email</font>
                        </th>
                        <th>
                            <font color="midnightblue">Address</font>
                        </th>
                        <th>
                            <font color="midnightblue">Message</font>
                        </th>
                    </tr>
                </thead>
                <tbody id="myTable">
                    {messageList.map((data,i) => (
                        <tr>
                            <td>{i+1}</td>
                            <td>{data.name}</td>
                            <td>{data.phone}</td>
                            <td>{data.email}</td>
                            <td>{data.address}</td>
                            <td>{data.message}</td>
                        </tr>
                    ))}

                </tbody>
            </table>
        </>
    )
}

export default MessageList;
